<template>
  <div class="select" :class="{ 'select--placeholder': placeholder && value === null }">
    <select class="select__element" v-model="valueComp" v-bind="$attrs">
      <option v-if="placeholder" :value="null" disabled dir="ltr">{{ placeholder }}</option>
      <slot>
        <option v-for="s in items" :key="s.value" :value="s.value" :disabled="s.disabled">{{ s.label }}</option>
      </slot>
    </select>
    <FontAwesomeIcon class="select__icon" :icon="['fal', 'angle-down']" size="lg" />
  </div>
</template>

<script>
export default {
  props: ['value', 'items', 'placeholder'],
  computed: {
    valueComp: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      },
    },
  },
}
</script>

<style lang="scss">
.select {
  position: relative;
  width: 100%;

  // &--placeholder {
  //   .select__element {
  //     color: rgba(black, 0.3);
  //   }
  // }

  &__element {
    appearance: none;
    width: 100%;
    height: 100%;
    padding: 1.1rem 2.5rem 1.1rem 1.1rem;
    border-radius: var(--border-radius);

    &:focus-visible {
      outline: 1px solid var(--primary);
    }
  }

  &__icon {
    position: absolute;
    right: 1.1rem;
    top: 50%;
    transform: translateY(-45%);
    color: inherit;
    opacity: 0.5;
    pointer-events: none;
  }
}
</style>
